// Tab bar across the detail page.

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Bar = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.NEU_100};
  margin-bottom: 20px;
`;

const Tab = styled.button`
  border: 0;
  background: none;
  font-family: inherit;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 16px;
  color: ${({ $active, theme }) => ($active ? theme.colors.PRIMARY : theme.colors.NEU_600)};
  border-bottom: 2px solid ${({ $active, theme }) => ($active ? theme.colors.PRIMARY : 'transparent')};
  cursor: pointer;

  &:hover { color: ${({ theme }) => theme.colors.PRIMARY}; }
`;

export const TABS = [
  { id: 'overview', labelKey: 'campaigns.tabs.overview', fallback: 'Overview' },
  { id: 'recipients', labelKey: 'campaigns.tabs.recipients', fallback: 'Recipients' },
  { id: 'content', labelKey: 'campaigns.tabs.content', fallback: 'Content' },
  { id: 'settings', labelKey: 'campaigns.tabs.settings', fallback: 'Settings' },
];

const CampaignTabs = ({ active, onChange }) => {
  const { t } = useTranslation();
  return (
    <Bar role='tablist'>
      {TABS.map((tab) => (
        <Tab
          key={tab.id}
          role='tab'
          aria-selected={active === tab.id}
          $active={active === tab.id}
          onClick={() => onChange(tab.id)}
        >
          {t(tab.labelKey, tab.fallback)}
        </Tab>
      ))}
    </Bar>
  );
};

export default CampaignTabs;
